module.exports = __webpack_public_path__ + "img/003-graphic-design-4.66683d26.svg";